import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { tap, finalize } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit {

  signupForm: FormGroup;
  loading = false;
  error = '';
  successmsg = false;
  token: string;
  userName: string;

  minCaracteres = false;
  maxCaracteres = false;
  hasNumber = false;
  hasMinus = false;
  hasMayus = false;
  espCaracter = false;

  loadIndicatorVisible = false;
	buttonText = 'Guardar';

  constructor(
    private authService: AuthenticationService,
              private toastService: ToastrService,
              private router: Router,
              private fb: FormBuilder,
              private cdr: ChangeDetectorRef,
              private route: ActivatedRoute) { }

  ngOnInit() {
    document.body.setAttribute('class', 'authentication-bg');
    
    // Obtener los parámetros de la URL (token y userName)
    this.route.queryParamMap.subscribe(queryParams => {
      this.userName = queryParams.get("email"); // Asegúrate de que el parámetro se llama 'email'
      this.token = queryParams.get("token").split(' ').join('+');
    });

    this.initSignupForm();
  }

  ngOnDestroy() { 
    document.body.classList.remove('authentication-bg');
  }

  initSignupForm() {
    this.signupForm = this.fb.group({
      newPassword: ['', Validators.compose([
        Validators.required,
        Validators.minLength(6),
        Validators.maxLength(16),
      ])],
      confirmPassword: ['', Validators.required],
    });
  }

  irLogin(){
    this.router.navigateByUrl('/login')
  }

  onSubmit() {
    this.loadIndicatorVisible = true;
    this.buttonText = 'Cargando...';
    if (this.signupForm.invalid) {
      this.loadIndicatorVisible = false;
      this.buttonText = 'Guardar';
      this.signupForm.markAllAsTouched();
      return;
    }

    this.loading = true;

    const resetPassword = {
      token: this.token,
      userName: this.userName,
      newPassword: this.signupForm.controls['newPassword'].value,
    };

    this.authService.resetPassword(resetPassword).pipe(
      finalize(() => {
        this.loading = false;
        this.cdr.markForCheck();
      })
    ).subscribe(
      result => {
        this.loadIndicatorVisible = false;
        this.buttonText = 'Guardar';
        this.router.navigateByUrl('/#/login');
        Swal.fire({
          title: '¡Operación Exitosa!',
          text: 'Se ha modificado correctamente su contraseña.',
          icon: 'success',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Confirmar',
      });
      },
      error => {
        this.loadIndicatorVisible = false;
        this.buttonText = 'Guardar';
        Swal.fire({
          title: '¡Ops!',
          text: error,
          icon: 'error',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Confirmar',
      });
      }
    );
  }

  type2 = 'password';
  type3 = 'password';

  myFunctionPasswordConfirm() {
    this.type2 = this.type2 === "password" ? "text" : "password";
  }

  myFunctionPasswordConfirmThre() {
    this.type3 = this.type3 === "password" ? "text" : "password";
  }

  onPasswordInput() {
    const newPassword = this.signupForm.controls['newPassword'].value;
    const confirmPassword = this.signupForm.controls['confirmPassword'].value;

    this.minCaracteres = newPassword.length >= 6;
    this.maxCaracteres = newPassword.length <= 16;
    this.hasNumber = /\d/.test(newPassword);
    this.hasMinus = /[a-z]/.test(newPassword);
    this.hasMayus = /[A-Z]/.test(newPassword);
    this.espCaracter = /[^\w\d]/.test(newPassword);

    // Verificar si las contraseñas coinciden
    if (newPassword !== confirmPassword) {
      this.signupForm.controls['confirmPassword'].setErrors({ mustMatch: true });
    } else {
      this.signupForm.controls['confirmPassword'].setErrors(null);
    }
  }
}
